import React from 'react';
import { FormatListBulleted as ListIcon } from '@mui/icons-material';
import { ReactComponent as ExpandIcon } from 'new/components/icons/expand.svg';
import { SegmentedControl } from 'new/elements/SegmentControl';

type ViewMode = 'list' | 'expanded';
type onChange = (expand: boolean) => void;
interface ExpandControllerProps {
  visible?: boolean;
  expanded: boolean;
  onChange: onChange;
}

const viewControls = [
  {
    value: 'list',
    label: 'List View',
    icon: <ListIcon style={{ borderRadius: 0 }} />,
  },
  {
    value: 'expanded',
    label: 'Expanded View',
    icon: <ExpandIcon style={{ borderRadius: 0 }} />,
  },
];

export const ExpandController: React.FC<ExpandControllerProps> = ({
  expanded,
  onChange,
  visible = false,
}) => {
  if (!visible) return null;

  const activeTab = expanded ? 'expanded' : 'list';

  const handleTabChange = (_: React.SyntheticEvent, mode: ViewMode) => {
    onChange?.(mode === 'expanded');
  };

  return (
    <SegmentedControl
      iconOnly
      controls={viewControls}
      defaultValue={viewControls[0].value}
      value={activeTab || viewControls[0].value}
      onControlChange={handleTabChange}
    />
  );
};
